import { render, staticRenderFns } from "./TableListHead.vue?vue&type=template&id=23d6dce6&"
import script from "./TableListHead.vue?vue&type=script&lang=js&"
export * from "./TableListHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports